export enum CommentDisplayStatus {
    Pending = 'pending-comment',
    Completed = 'completed-comment'
}
